
(function(){
  var cv=document.getElementById('fluid'); if(!cv||!cv.getContext) return;
  var ctx=cv.getContext('2d'); if(!ctx) return;
  var DPR=Math.min(window.devicePixelRatio||1,1.25), W=0,H=0,M=0;
  function size(){ W=cv.clientWidth||window.innerWidth; H=cv.clientHeight||window.innerHeight; cv.width=Math.round(W*DPR); cv.height=Math.round(H*DPR); ctx.setTransform(DPR,0,0,DPR,0,0); M=Math.max(W,H); }
  size(); window.addEventListener('resize',size);
  var B=[
    {t:'243,237,227',r:.72,x:.28,y:.3,ax:.11,ay:.08,fx:.00034,fy:.00026,a:.62,pr:.00034,ph:0},
    {t:'228,216,194',r:.62,x:.74,y:.36,ax:.1,ay:.11,fx:.00038,fy:.00028,a:.52,pr:.00038,ph:1.6},
    {t:'237,229,214',r:.54,x:.44,y:.8,ax:.12,ay:.07,fx:.00030,fy:.00034,a:.48,pr:.00034,ph:3.1},
    {t:'222,208,184',r:.52,x:.84,y:.74,ax:.09,ay:.1,fx:.00042,fy:.00030,a:.44,pr:.00042,ph:4.4},
    {t:'239,231,217',r:.46,x:.2,y:.62,ax:.11,ay:.08,fx:.00034,fy:.00036,a:.4,pr:.00036,ph:5.6},
    {t:'230,218,198',r:.42,x:.56,y:.16,ax:.1,ay:.07,fx:.00032,fy:.00038,a:.36,pr:.00034,ph:2.3}
  ];
  var run=true;
  document.addEventListener('visibilitychange',function(){run=!document.hidden; if(run)requestAnimationFrame(frame);});
  function frame(tm){
    ctx.clearRect(0,0,W,H);
    for(var i=0;i<B.length;i++){var b=B[i];
      var cx=(b.x+b.ax*Math.sin(tm*b.fx+b.ph))*W;
      var cy=(b.y+b.ay*Math.cos(tm*b.fy+b.ph))*H;
      var rad=b.r*(1+.1*Math.sin(tm*b.pr+b.ph))*M;
      var lx=cx-rad*.3, ly=cy-rad*.34;
      var g=ctx.createRadialGradient(lx,ly,rad*.03,cx,cy,rad);
      g.addColorStop(0,'rgba(255,255,255,'+b.a+')');
      g.addColorStop(.36,'rgba(248,247,244,'+(b.a*.64)+')');
      g.addColorStop(.72,'rgba('+b.t+','+(b.a*.42)+')');
      g.addColorStop(1,'rgba('+b.t+',0)');
      ctx.fillStyle=g; ctx.fillRect(0,0,W,H);
    }
    if(run)requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
})();

  const $=s=>document.querySelector(s), $$=s=>[...document.querySelectorAll(s)];
  const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;

  (function(){
    var track=document.getElementById('revTrack'); if(!track) return;
    var dots=[].slice.call(document.querySelectorAll('#revDots button'));
    var n=track.children.length, idx=0, timer=null;
    function go(k){ idx=(k+n)%n; track.style.transform='translateX(-'+(idx*100)+'%)'; for(var d=0;d<dots.length;d++)dots[d].classList.toggle('on',d===idx); }
    function nxt(){ go(idx+1); } function prv(){ go(idx-1); }
    function stop(){ if(timer){clearInterval(timer);timer=null;} }
    function start(){ if(!timer)timer=setInterval(nxt,5000); }
    var pB=document.getElementById('revPrev'), nB=document.getElementById('revNext');
    if(pB)pB.addEventListener('click',function(){stop();prv();start();});
    if(nB)nB.addEventListener('click',function(){stop();nxt();start();});
    for(var d=0;d<dots.length;d++){(function(x){dots[x].addEventListener('click',function(){stop();go(x);start();});})(d);}
    var vp=document.getElementById('revVp');
    if(vp){var x0=null;
      vp.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;stop();},{passive:true});
      vp.addEventListener('touchend',function(e){if(x0===null){start();return;}var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40){dx<0?nxt():prv();}x0=null;start();});
    }
    if('IntersectionObserver' in window && vp){ new IntersectionObserver(function(es){for(var i=0;i<es.length;i++){es[i].isIntersecting?start():stop();}},{threshold:.25}).observe(vp); } else { start(); }
    go(0);
  })();
  var _yr=$('#yr');if(_yr)_yr.textContent=new Date().getFullYear();
  requestAnimationFrame(()=>requestAnimationFrame(()=>{var h=$('#hero');if(h)h.classList.add('ready');}));

  const hdr=$('#hdr'); const onH=()=>hdr.classList.toggle('shrink',scrollY>40); onH(); addEventListener('scroll',onH,{passive:true});

  const menuBtn=$('#menuBtn'), mmenu=$('#mobileMenu');
  function closeMenu(){mmenu.classList.remove('open');menuBtn.classList.remove('x');menuBtn.setAttribute('aria-expanded','false');mmenu.setAttribute('aria-hidden','true');document.body.style.overflow='';}
  menuBtn.addEventListener('click',()=>{const o=mmenu.classList.toggle('open');menuBtn.classList.toggle('x',o);menuBtn.setAttribute('aria-expanded',o);mmenu.setAttribute('aria-hidden',String(!o));document.body.style.overflow=o?'hidden':'';});
  mmenu.querySelectorAll('a').forEach(a=>a.addEventListener('click',closeMenu));
  addEventListener('keydown',e=>{if(e.key==='Escape')closeMenu();});

  const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}}),{threshold:.1,rootMargin:'0px 0px -6% 0px'});
  $$('.rv,.stg').forEach(el=>io.observe(el));

  function runCount(el,dur){
    const t=+el.dataset.count,v=el.querySelector('.v');
    if(el._raf)cancelAnimationFrame(el._raf);
    const t0=performance.now();
    const tick=n=>{const p=Math.min(1,(n-t0)/dur);v.textContent=Math.round(t*(1-Math.pow(1-p,3)));if(p<1)el._raf=requestAnimationFrame(tick);};
    el._raf=requestAnimationFrame(tick);
  }
  const statIO=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){statIO.unobserve(e.target);runCount(e.target,1200);}}),{threshold:.5});
  $$('.stat .num').forEach(el=>statIO.observe(el));
  if(matchMedia('(hover:hover) and (pointer:fine)').matches){
    $$('.stat').forEach(card=>{const num=card.querySelector('.num');if(num)card.addEventListener('pointerenter',()=>runCount(num,700));});
  }

  (function(){
    const slides=$$('.hstep'), rail=$$('#hRail button'), num=$('#hNum'), nums=['01','02','03'];
    if(!slides.length||!num)return;
    let i=0, timer=null, used=false;
    function set(n){i=(n+slides.length)%slides.length;slides.forEach((s,k)=>s.classList.toggle('on',k===i));rail.forEach((b,k)=>b.classList.toggle('on',k===i));num.textContent=nums[i];}
    const next=()=>set(i+1), prev=()=>set(i-1);
    function stop(){used=true;if(timer){clearInterval(timer);timer=null;}}
    $('#hNext').addEventListener('click',()=>{next();stop();});
    $('#hPrev').addEventListener('click',()=>{prev();stop();});
    rail.forEach(b=>b.addEventListener('click',()=>{set(+b.dataset.i);stop();}));
    const area=$('#hSlides'); let x0=null;
    area.addEventListener('touchstart',e=>{x0=e.touches[0].clientX;},{passive:true});
    area.addEventListener('touchend',e=>{if(x0==null)return;const dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40){dx<0?next():prev();stop();}x0=null;},{passive:true});
    function start(){if(reduce||used||timer)return;timer=setInterval(next,4500);}
    const vio=new IntersectionObserver(es=>es.forEach(e=>{e.isIntersecting?start():(timer&&(clearInterval(timer),timer=null));}),{threshold:.4});
    var _h=$('#how');if(_h)vio.observe(_h);
  })();

  const opts=$('#opts'),buyAdd=$('#buyAdd');
  if(opts&&buyAdd)opts.addEventListener('click',e=>{const o=e.target.closest('.opt');if(!o)return;[...opts.children].forEach(x=>x.classList.remove('sel'));o.classList.add('sel');buyAdd.querySelector('span').textContent='Add to cart — $'+o.dataset.price+(o.dataset.price==='29'?'/mo':'');});

  let cart=0;const cartN=$('#cartN');
  function flash(b,t){const s=b.querySelector('span'),o=s.textContent;s.textContent=t;b.disabled=true;setTimeout(()=>{s.textContent=o;b.disabled=false;},1100);}
  $$('[data-add]').forEach(b=>b.addEventListener('click',()=>{cart++;cartN.textContent=cart;flash(b,'Added ✓');}));

  $$('.ai .aq').forEach(q=>q.addEventListener('click',()=>{
    const item=q.parentElement,panel=item.querySelector('.aa'),open=item.classList.contains('open');
    $$('.ai').forEach(x=>{x.classList.remove('open');x.querySelector('.aa').style.maxHeight=null;});
    if(!open){item.classList.add('open');panel.style.maxHeight=panel.scrollHeight+'px';}
  }));

  const jb=$('#joinBtn'),em=$('#email');
  if(jb&&em)jb.addEventListener('click',()=>{if(em.value&&em.value.includes('@')){jb.querySelector('span').textContent='You\u2019re in ✓';em.value='';}else{em.focus();}});
